import React from 'react';
import { CCard, CCardBody } from '@coreui/react';
import { WidgetConfig, WidgetType } from '../../../shared/models/insights';
import FeedbackRating from '../../../shared/components/FeedbackRating';

const ValueRenderer = (type, value) => {
  switch (type) {
    case WidgetType.Value:
      return value;
    case WidgetType.Percent:
      return <div>{value} %</div>;
    case WidgetType.Rating:
      return <FeedbackRating rating={value} />;
    default:
      return value;
  }
};

interface CardWidgetProps {
  widget: WidgetConfig;
  data: string | number;
  clickHandler: (name) => void;
}

const CardWidget = ({widget, data, clickHandler}: CardWidgetProps) => {
  return (
    <CCard className="h-100 w-100 glympser-container--rounded" {...(widget.completedTasksScreen ? { onClick: () => clickHandler(widget.field)} : {})}>
      <CCardBody className={`text-center ${widget.completedTasksScreen ? "cursor-pointer": ''}`}>
        <div className="text-muted small text-uppercase font-weight-bold">
          {widget.title}
        </div>
        <div className="h2 w-100 mb-0">{ValueRenderer(widget.type, data)}</div>
      </CCardBody>
    </CCard>
  );
};

export default CardWidget;
